import { ObjectFieldTemplateProps } from "@rjsf/utils";

function LocationTemplate(props: ObjectFieldTemplateProps, func: any) {
  return (
    <>
      <div className="cms-section">
        <div className="h3">{props.title}</div>
        <div className="section row">
          <div className="col-12">
            <div className="property-wrapper">
              {func("location_type", props)?.content}
            </div>
          </div>
          <div className="col-12">
            <div className="property-wrapper">
              {func("address", props)?.content}
            </div>
          </div>
          <div className="col-12">
            <div className="property-wrapper">
              {func("iframe", props)?.content}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default LocationTemplate;
